import { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { onAuthStateChange } from '../../../services/authService'

/**
 * ProtectedRoute component
 * Wraps routes that require authentication
 * Redirects to login if user is not authenticated
 */
const ProtectedRoute = ({ children }) => {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    // Subscribe to auth state changes
    const unsubscribe = onAuthStateChange((userData) => {
      setUser(userData)
      setLoading(false)
    })

    // Cleanup subscription on unmount
    return () => unsubscribe()
  }, [])

  // Show loading state while checking authentication
  if (loading) {
    return (
      <div className="psyber-container" style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh'
      }}>
        <div className="psyber-card" style={{ textAlign: 'center', padding: '2rem' }}>
          <i className="fas fa-spinner fa-spin" style={{
            fontSize: '3rem',
            color: 'var(--psyber-primary)',
            marginBottom: '1rem'
          }}></i>
          <p style={{ color: 'var(--psyber-text-secondary)' }}>Loading...</p>
        </div>
      </div>
    )
  }

  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to="/login" replace />
  }

  // Render protected content if authenticated
  return children
}

export default ProtectedRoute
